/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SessionTimeout} from '@ion/dls/src/notifications/SessionTimeout';
import {deleteIONSession, sessionTimeout} from '@/store/actions/login';

/**
 * The SessionExpired component provides the top-level session timeout UI within
 * the iOn Application.
 */
export const SessionExpired = () => {
  const dispatch = useDispatch();
  const isSessionTimeout = useSelector(({errors}) => errors.error?.isUnauthorizedError);
  useEffect(() => {
    if (isSessionTimeout) {
      deleteIONSession();
    }
  }, [isSessionTimeout]);
  if (isSessionTimeout) {
    return (
      <SessionTimeout show onLogin={function() {
        dispatch(sessionTimeout() as any);
      }} />
    );
  }
  return null;
};
export default SessionExpired;
